<template>
    <div>
        <div v-if="format == 'small'">


        <div style="text-align:center">
            <div style="font-size:5em">{{actions.length}}</div>
        </div>

            <div v-if="actions.length > 0">
                Prochaine action: {{actions[0].name}}
            </div>
        </div>
        <div v-else>
            <ActionsView :minimal="true"></ActionsView>
        </div>
    </div>

</template>

<script>
    import users from "../../services/users.js";
	import ActionsView from "../../views/Actions.vue";
    import userActions from "../../services/userActions.js";
    
    export default {
		components: {
            ActionsView
		},
        props: {
            format: {
                default: "small"
            },
            test_jwt: {
                default: null
            }
        },
        data: function () {
            return {
                text: "",
                actions: []
            };
        },
        watch: {

			event: async function (event) {
				if (event.type == "actions" || event.type == "action")
				{
					var data = JSON.parse(event.data);

					if (event.action == "insert" || (event.action == "update" && data.new.hasOwnProperty("active") && data.new.active > 0))
					{
						var actions = await userActions.get("SELECT", this.table, {
							where: '`id` = ' + event.id_data
						}, false, this.test_jwt);

						this.actions.push(actions[0]);

					}
					if (event.action == "delete" || (event.action == "update" && data.new.hasOwnProperty("active") && data.new.active <= 0))
					{
						for (var i = 0; i < this.actions.length; i++)
						{
							if (this.actions[i].id == event.id_data)
							{
								this.actions.splice(i, 1);
								i--;
							}
						}
					}
				}
			}
        },
		methods: {
            async load(data)
            {
                if (this.format == "small")
                {
                    let response = await users.getSelf(true);
                    this.params = response.client.details.actions;
                    this.help = this.params.help || {};

                    this.table = this.params.table;

                    var actions = await userActions.get("SELECT", this.table, {
                        where: '`' + this.params.column_active + '`' + " > 0 ORDER BY id ASC"
                    }, false, this.test_jwt);

                    if (actions)
                    {
                        this.actions = actions;
                    }
                }
            }
		},
		mounted: function () {

		},
    }


</script>